/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Avatar_Select_ImageInputs */



/**
* | output |
* | --- |
* | "Click to select an image" |
*
* @param {Avatar_Select_ImageInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const avatar_select_image = /** @type {((inputs?: Avatar_Select_ImageInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Avatar_Select_ImageInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cliquez pour sélectionner une image")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haga clic para seleccionar una imagen")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Clique para selecionar uma imagem")
	if (locale === "it") return /** @type {LocalizedString} */ ("Clicca per selezionare un'immagine")
	return /** @type {LocalizedString} */ ("Click to select an image")
});